import { render, staticRenderFns } from "./NewSwiper.vue?vue&type=template&id=1bfd84db&scoped=true"
import script from "./NewSwiper.vue?vue&type=script&lang=js"
export * from "./NewSwiper.vue?vue&type=script&lang=js"
import style0 from "./NewSwiper.vue?vue&type=style&index=0&id=1bfd84db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd84db",
  null
  
)

export default component.exports